import { useTranslation } from 'react-i18next';
import React from 'react';
import { useServeFileById } from '@/hooks/upload/use-file';

type SignatureData = { choice: string; fileName: string; signatureData?: string };

interface SignatureResponseProps {
  response: string | SignatureData;
  label: string;
}

const SignatureResponse: React.FC<SignatureResponseProps> = ({ response }) => {
  const { t } = useTranslation();

  const sig: SignatureData | null =
    response && typeof response === 'object' ? (response as SignatureData) : null;

  const inlineData = sig?.signatureData?.startsWith('data:') ? sig.signatureData : null;
  const fileId = sig?.fileName || (typeof response === 'string' ? response : '');

  const { data: blobUrl, isLoading, error } = useServeFileById(inlineData ? '' : fileId);

  const imageUrl = inlineData ?? blobUrl;

  if (!inlineData && isLoading) {
    return (
      <div className="mb-4 mt-2">
        <div className="border-2 border-gray-300 rounded-md max-w-full h-32 bg-gray-200 animate-pulse" />
      </div>
    );
  }

  if (!imageUrl || error) {
    return (
      <div className="mb-4 mt-2">
        <div className="border-2 border-gray-300 rounded-md max-w-full h-32 bg-gray-100 flex items-center justify-center text-gray-400 text-sm">
          {t('formResponses.signatureUnavailable', 'Signature unavailable')}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4 mt-2">
      <img
        src={imageUrl}
        alt={t('formResponses.signature')}
        className="border-2 border-gray-300 rounded-md max-w-full h-auto"
      />
    </div>
  );
};

export default SignatureResponse;